module.exports = __webpack_public_path__ + "img/857c161.jpg";